import { useDownloadImportLicensingDocumentFileMutation } from '@/generated/graphql-react-query';

export const useDownloadFile = () => {
  const { mutateAsync } = useDownloadImportLicensingDocumentFileMutation();

  return {
    download: mutateAsync,
  };
};
